import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './Components/context/AuthContext';

const ProtectedRoute = ({ allowedPermissions }) => {
  const { authToken, userData } = useAuth();
  const location = useLocation();

  if (!authToken || !userData) {
    return <Navigate to="/login" replace />;
  }

  // Allow SuperAdmin to access everything without restriction
  if (userData.role === "SuperAdmin") {
    return <Outlet />;
  }

  // Allow all users to access the dashboard
  if (location.pathname === "/dashboard" ||location.pathname === "/permissionDenied" ) {
    return <Outlet />;
  }

  const userPermissions = JSON.parse(userData.permissions || "[]");

  // Check if the user has at least one required permission
  const hasPermission = allowedPermissions.some(permission => userPermissions.includes(permission));

  return hasPermission ? <Outlet /> : <Navigate to="/permissionDenied" replace />;
};

export default ProtectedRoute;